<template>
	<div>

		<date-picker :clearable="options.clearable" :range="options.range" v-on:change="change" :not-before="options.not_before" :shortcuts="options.shortcuts" :format="options.format" :lang="t.times" v-model="time" :first-day-of-week="options.firstDay"></date-picker>
	</div>
</template>

<script>
    import { abstractField } from "vue-form-generator";
    import DatePicker from 'vue2-datepicker'

    export default {
        name: 'vfg-field-datepicker',
        mixins: [ abstractField ],
        data () {
            return {
                session: this.$root.session,
	            t: this.$root.t,
                // for Vue 1.0
                time: this.value,
	            options: this.schema.options
            }
        },
	    methods: {
            change (c) {

                this.time = c;

                this.update()

            },
		    update (){
                this.value = ''
                if(Array.isArray(this.time)) {

                    if(typeof this.time[0].getMonth === 'function' || typeof this.time[1].getMonth === 'function') {
                        this.value = {
                            from: this.moment(this.time[0]).utc().format(this.options.dataFormat),
                            to: this.moment(this.time[1]).utc().format(this.options.dataFormat)
                        }
                    }else {
                        this.value = ''
                    }

                }else if(typeof this.time.getMonth === 'function') {
                    this.value =  this.moment(this.time).utc().format(this.options.dataFormat);
                }else {
                    this.value = ''
                }
		    }
	    },
        components: {
            'date-picker': DatePicker
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.mx-datepicker-range{
		width: 98%;
	}
</style>



// WEBPACK FOOTER //
// src/components/form/fieldDatetime.vue